import CircularProgress from '@mui/material/CircularProgress';
import './scss/LoaderOverlay.css';

interface LoaderOverlayProps {
  isAbsolute?: boolean;
  isOverlay?: boolean;
  isSubmitting?: boolean;
}

export const LoaderOverlay = ({
  isAbsolute,
  isOverlay,
  isSubmitting,
}: LoaderOverlayProps) => {
  if (isOverlay) {
    return (
      <div
        className={`loader-overlay ${!isSubmitting ? 'loader-hidden' : ''}`}
        data-testid="loader-overlay"
      >
        <div className={`loader-spinner ${isAbsolute ? 'absolute' : ''}`}>
          <CircularProgress size={65} thickness={2} aria-label="Loading..." />
        </div>
      </div>
    );
  }
  return (
    <div
      className={`loader-spinner ${isAbsolute ? 'absolute' : ''}`}
      data-testid="loader-overlay"
    >
      <CircularProgress size={65} thickness={2} aria-label="Loading..." />
    </div>
  );
};
